module.exports = __webpack_public_path__ + "img/display.ca8db3cd.svg";